export enum StateCode {
  CALIFORNIA = 'CA',
}
